import FilterAccordion from '../FilterAccordion';
import Checkboxes from '../Checkboxes';
import Tags from '../Tags';
import Autocomplete from '../Autocomplete';
import Radios from '../Radios';
import Select from '../Select';
import GooglePlacesAuto from '../../../Molecules/GooglePlacesAuto';
import { useAnalyticsPushEvent } from '../../../../analytic/analytic.context';

const FormField = ({
  fieldConfig,
  state,
  onChange,
  setState,
  analyticsData,
  ...rest
}) => {
  const pushAnalyticEvent = useAnalyticsPushEvent();
  const { type, label, wrapInAccordion, isFacet, hidden = false } = fieldConfig;

  if (!type || hidden) {
    return '';
  }

  const onChangeAnalytics = (filterValue) => {
    if (!analyticsData) {
      return undefined;
    }

    switch (analyticsData?.event) {
      case 'list_filtered':
        return pushAnalyticEvent({
          ...analyticsData,
          filter_name: fieldConfig.label,
          filter_value: filterValue,
        });
      default:
        return undefined;
    }
  };

  const removeOption = (optionsArray = [], removeValue) => {
    if (Array.isArray(optionsArray)) {
      return optionsArray.filter((item) => item !== removeValue);
    }
    return '';
  };

  const handleChange = (event) => {
    const {
      name: fieldName,
      value,
      checked,
      type: fieldType,
      dataset,
    } = event.target;

    setState((prev) => {
      if (fieldType === 'checkbox') {
        const { name: optionName, label: optionLabel } = dataset;
        const val = isFacet ? `${optionName}:${value}` : value;

        if (checked) {
          onChangeAnalytics(
            isFacet
              ? optionLabel
                  .substring(0, optionLabel.length - 4)
                  .replace(/\([^)]*\)/, '')
              : val,
          );

          return {
            ...prev,
            [optionName]: [...(prev[`${optionName}`] || []), val],
          };
        }

        return {
          ...prev,
          [optionName]: removeOption(prev[`${optionName}`], val),
        };
      }

      if (fieldType === 'radio') {
        const { name: optionName, label: optionLabel } = dataset;
        const val = isFacet ? `${optionName}:${value}` : value;
        onChangeAnalytics(val || optionLabel);

        return {
          ...prev,
          [optionName]: val,
        };
      }

      if (dataset.filterType === 'tag') {
        const { name: tagName, value: tagValue, checked: tagChecked } = dataset;

        if (tagChecked !== 'true') {
          onChangeAnalytics(tagValue);
          return {
            ...prev,
            [tagName]: [...(prev[`${tagName}`] || []), tagValue],
          };
        }

        return {
          ...prev,
          [tagName]: removeOption(prev[`${tagName}`], tagValue),
        };
      }

      if (type === 'select') {
        onChangeAnalytics(value || event.target.selectedOptions[0].innerText);
      }

      return {
        ...prev,
        [fieldName]: isFacet ? `${fieldName}:${value}` : value,
      };
    });

    if (typeof onChange === 'function') {
      onChange(fieldConfig, event);
    }
  };

  const renderField = () => {
    const mapping = {
      checkboxes: Checkboxes,
      tags: Tags,
      autocomplete: Autocomplete,
      radios: Radios,
      select: Select,
      regionId: GooglePlacesAuto,
    };

    const Component = mapping[`${type}`] ? mapping[`${type}`] : '';

    const onSearchAnalyticsProps =
      type === 'autocomplete' ? analyticsData : undefined;

    if (Component) {
      const settings = { ...fieldConfig, state };

      if (type === 'regionId') {
        if (wrapInAccordion) {
          return (
            <FilterAccordion label={label}>
              <Component
                inputDefaultValue={fieldConfig.inputDefaultValue || ''}
                onPlaceSelected={fieldConfig.onPlaceSelected}
                {...fieldConfig.rest}
              />
            </FilterAccordion>
          );
        }

        return (
          <Component
            label={label}
            inputDefaultValue={fieldConfig.inputDefaultValue || ''}
            onPlaceSelected={fieldConfig.onPlaceSelected}
            affectCookie={true}
            {...fieldConfig.rest}
          />
        );
      }

      if (wrapInAccordion) {
        return (
          <FilterAccordion label={label}>
            <Component
              settings={{ ...settings, label: '' }}
              onChange={handleChange}
              setState={setState}
              children={fieldConfig.children}
              onSearchAnalytics={onSearchAnalyticsProps}
              {...rest}
            />
          </FilterAccordion>
        );
      }

      return (
        <Component
          settings={settings}
          onChange={handleChange}
          setState={setState}
          children={fieldConfig.children}
          onSearchAnalytics={onSearchAnalyticsProps}
          {...rest}
        />
      );
    }

    return '';
  };

  return <>{renderField()}</>;
};

export default FormField;
